import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './__mocks__';
import { Report } from './types/types';

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/reports`,
  }),
  tagTypes: ['Reports'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getReports: builder.query<Report[], void>({
      query: () => ({
        url: ``,
      }),
      providesTags: ['Reports'],
    }),
  }),
});

export const { useGetReportsQuery } = reportsApi;
